import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export function logoForBrand(makes, brand) {
  if (!brand || !makes?.length) return null;
  const needle = String(brand).trim().toLowerCase();
  const match = makes.find(
    (item) =>
      item.name?.toLowerCase() === needle || item.slug?.toLowerCase() === needle
  );
  return match?.logo_url || null;
}

export function useBrandLogos() {
  const [makes, setMakes] = useState([]);
  useEffect(() => {
    let alive = true;
    supabase
      .from('vehicle_makes')
      .select('name, slug, logo_url')
      .then(({ data }) => {
        if (alive) setMakes(data || []);
      });
    return () => {
      alive = false;
    };
  }, []);
  return makes;
}

export default function BrandMark({ name, src, compact = false }) {
  const [failed, setFailed] = useState(false);
  const className = compact ? 'brand-logo brand-logo-sm' : 'brand-logo';
  if (!src || failed) {
    return (
      <span className={compact ? 'brand-fallback brand-fallback-sm' : 'brand-fallback'}>
        {(name || '?').slice(0, 1)}
      </span>
    );
  }
  return (
    <img
      className={className}
      src={src}
      alt=""
      onError={() => setFailed(true)}
    />
  );
}
